var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeenBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.181 9c.94-5.12 5.427-9 10.82-9 5.391 0 9.877 3.88 10.818 9-.94 5.12-5.427 9-10.819 9C5.608 18 1.122 14.12.181 9zm10.82 5A5 5 0 1011 4a5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z"
  })));
}

export default SvgSeenBy;